import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import Avatar from 'material-ui/Avatar';
import CircularProgress from 'material-ui/CircularProgress';
import Paper from 'material-ui/Paper';
import RefreshIndicator from 'material-ui/RefreshIndicator';

const styles = {
  content: {
    margin: '1em',
    textAlign: 'center',
    display: 'flex',
    padding: '1em',
    justifyContent: 'space-between',
    borderRadius: '10px !important',
  },
  avatar: {
    border: 'solid 1px #bbb',
    flex: '0 0 auto',
    left: '0 !important',
    position: 'relative !important',
    top: 'inherit !important',
  },
  companyName: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    paddingLeft: '1em',
    fontSize: '1em',
  },
  loading: {
    margin: 'auto',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

class GeneralInfo extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      classes,
      partnerInfo: { companyName = '?', profileImageUrl } = {},
      partnerInfoLoading,
      partnerInfoLoaded,

    } = this.props;
    const whatToShow = (() => {
      if (partnerInfoLoading) return 'loading';
      if (partnerInfoLoaded) return 'loaded';
      return 'errored';
    })();
    return {
      'loaded': (
        <Paper className={classes.content}>
          <Avatar
            className={classes.avatar}
            {...(profileImageUrl) ? ({ src: profileImageUrl }) : {} }
          >
            {profileImageUrl ? null : companyName[0].toUpperCase()}
          </Avatar>
        <div className={classes.companyName}>{companyName}</div>
        </Paper>
      ),
      'loading': (
        <Paper className={classes.content}>
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        </Paper>
      ),
      'errored': (
        <Paper className={classes.content}>
          <div className={classes.loading}>
            <RefreshIndicator
              percentage={80}
              size={60}
              left={0}
              top={0}
              color="red"
              status="ready"
              style={styles.refresh}
            />
          </div>
        </Paper>
      ),
    }[whatToShow];
  }
}

GeneralInfo.propTypes = {
  classes: PropTypes.object,
  partnerInfo: PropTypes.object,
  partnerInfoLoaded: PropTypes.bool,
  partnerInfoLoading: PropTypes.bool,
};

const select = ({ partnerDetails: store }) => ({
  partnerInfo: store.partnerInfo,
  partnerInfoLoaded: store.partnerInfoLoaded,
  partnerInfoLoading: store.partnerInfoLoading,
});

export default connect(select, {})(injectSheet(styles)(GeneralInfo));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/general-info.jsx